import React, {useState} from 'react'
import ClientSuspense from '@components/ClientSuspense'
import Section from '@page-components/CheckoutV3/components/Section'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import useSections from '@page-components/CheckoutV3/hooks/useSections'
import {useTranslation} from 'next-i18next'

import CouponIcon from './CouponIcon'
import Edit from './Edit'
import CouponSkeleton from './Skeleton'

function Coupon() {
  const sections = useSections()
  const {preferences} = usePreferences()
  const [openSection, setOpenSection] = useState(!!preferences.couponCode)
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'coupon'})
  if (!sections.includes('coupon')) return null
  return (
    <Section
      id="coupon"
      className="py-6 md:py-2"
      smallPill
      caretDirection={openSection ? 'up' : 'down'}
      transparentOnDesktop
      icon={<CouponIcon />}
      onClick={() => setOpenSection(!openSection)}
      subsection={openSection && <Edit />}>
      <div className="py-0 md:py-2 text-base md:text-sm">{t('title')}</div>
    </Section>
  )
}

export default function CouponWrapper() {
  return (
    <ClientSuspense fallback={<CouponSkeleton />}>
      <Coupon />
    </ClientSuspense>
  )
}
